import axios from 'axios'
import {
  ALLTENANTUSAGE,
  ALLTENANTUSAGE_DOWNLOAD_CSV,
  TOP_FEATURES_MONTHLY,
  TOP_TENANTS,
  TOP_TENANTS_DOWNLOAD_CSV,
  RECENT_TENANTS,
  RECENT_TENANTS_DOWNLOAD_CSV,
  RECENT_FEATURES,
  RECENT_FEATURES_DOWNLOAD_CSV,
  RISKY_TENANTS,
  RISKY_TENANTS_DOWNLOAD_CSV,
  RISKY_FEATURES,
  RISKY_FEATURES_DOWNLOAD_CSV,
  OVERALL_FEATURE_COUNT
} from './index.js'

export const getAllTenantUsage = ({ plan = null, page = 1, per_page = 10 } = {}) => {
    const params = new URLSearchParams()
    if (plan) params.append('plan', plan)
    if (page) params.append('page', page)
    if (per_page) params.append('per_page', per_page)
    const qs = params.toString()
    const url = qs ? `${ALLTENANTUSAGE}?${qs}` : ALLTENANTUSAGE
    return axios.get(url)
}

export const downloadAllTenantUsageCsv = () => {
    return axios.get(ALLTENANTUSAGE_DOWNLOAD_CSV)
}

export const getTopFeaturesMonthly = (plan = null) => {
    const url = plan ? `${TOP_FEATURES_MONTHLY}?plan=${plan}` : TOP_FEATURES_MONTHLY;
    return axios.get(url)
}

export const getTopTenants = (plan = null) => {
    const url = plan ? `${TOP_TENANTS}?plan=${plan}` : TOP_TENANTS;
    return axios.get(url)
}

export const downloadTopTenantsCsv = () => {
    return axios.get(TOP_TENANTS_DOWNLOAD_CSV)
}

export const getRecentTenants = (plan = null) => {
    const url = plan ? `${RECENT_TENANTS}?plan=${plan}` : RECENT_TENANTS;
    return axios.get(url)
}

export const downloadRecentTenantsCsv = () => {
    return axios.get(RECENT_TENANTS_DOWNLOAD_CSV)
}

export const getFeatureAnalytics = ({ feature, plan, year, search, page, per_page, date_operator, date }) => {
    const params = new URLSearchParams()
    if (plan) params.append('plan', plan)
    if (year) params.append('year', year)
    if (search) params.append('search', search)
    if (page) params.append('page', page)
    if (per_page) params.append('per_page', per_page)
    if (date_operator) params.append('date_operator', date_operator)
    if (date) params.append('date', date)
    const qs = params.toString()
    const base = `${ALLTENANTUSAGE}/${encodeURIComponent(feature)}`
    const url = qs ? `${base}?${qs}` : base
    return axios.get(url)
}

export const downloadFeatureAnalyticsCsv = ({ feature, plan, year, search, date_operator, date }) => {
    const params = new URLSearchParams()
    if (plan) params.append('plan', plan)
    if (year) params.append('year', year)
    if (search) params.append('search', search)
    if (date_operator) params.append('date_operator', date_operator)
    if (date) params.append('date', date)
    const qs = params.toString()
    const base = `${ALLTENANTUSAGE}/${encodeURIComponent(feature)}/download-csv`
    const url = qs ? `${base}?${qs}` : base
    return axios.get(url, { responseType: 'blob' })
}

export const getRecentFeatures = (plan = null) => {
    const url = plan ? `${RECENT_FEATURES}?plan=${plan}` : RECENT_FEATURES;
    return axios.get(url)
}

export const downloadRecentFeaturesCsv = () => {
    return axios.get(RECENT_FEATURES_DOWNLOAD_CSV)
}

export const getRiskyTenants = (plan = null) => {
    const url = plan ? `${RISKY_TENANTS}?plan=${plan}` : RISKY_TENANTS;
    return axios.get(url)
}

export const downloadRiskyTenantsCsv = () => {
    return axios.get(RISKY_TENANTS_DOWNLOAD_CSV)
}

export const getRiskyFeatures = (plan = null) => {
    const url = plan ? `${RISKY_FEATURES}?plan=${plan}` : RISKY_FEATURES;
    return axios.get(url)
}

export const downloadRiskyFeaturesCsv = () => {
    return axios.get(RISKY_FEATURES_DOWNLOAD_CSV)
}

export const getOverallFeatureCount = (plan = null) => {
    const url = plan ? `${OVERALL_FEATURE_COUNT}?plan=${plan}` : OVERALL_FEATURE_COUNT;
    return axios.get(url)
}
